import Navbar from "../Components/Header/Navbar";
import { Title } from "../Components/Header/Title";
import WizardDevice from "../Components/WizardDevice";
import Footer from "../Components/Footer/Footer";
import { PlayerReview } from "../Components/PlayerReview";
import { Streaming } from "../Components/Streaming";
import CookiesBanner from "../Components/Cookies/CookiesBanner"; // Importar el componente
import Downloads from "../Components/Downloads";
import { WizardPlatform } from "src/Components/WizarPlatform";

export const Home = () => {
  return (
    <div>
      <CookiesBanner /> {/* Mostrar el banner de cookies */}
      <div>
        <Navbar />
      </div>
      <div>
        <Title />
      </div>
      <div>
        <WizardPlatform />
      </div>
      <div>
        <WizardDevice />
      </div>
      <div>
        <Streaming />
      </div>
      <div>
        <PlayerReview />
      </div>
      <div>
        <Downloads />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
